export const LIMIT_GRAPH = 1000;

export const LIMIT_TREED = 30;
